import Config from '@/utils/Config';

export const currAccount = (state) => {
    if (state.accountList && state.accountList[state.currAccountIndex]) {
        return state.accountList[state.currAccountIndex];
    }
    return null;
};

export const currAddress = state => {
    if (state.accountList && state.accountList[state.currAccountIndex]) {
        if (state.accountList[state.currAccountIndex].userid) {
            return state.accountList[state.currAccountIndex].userid;
        }
        return state.accountList[state.currAccountIndex].address;
    }
    return null;
};
export const publicPath = (state) => {
    const { webContent: { config: { publicPath: webPath } = {} } = {} } = state;
    return webPath || Config.publicPath;
}
export const webConfig = (state) => {
    const { webContent: { config = {} } = {} } = state;
    return config;
};
export const kycStatus = state => {
    const { kycStatus: status, kycType, emailVerify, phoneVerify } =
        state.kycInfo || {};
    if (status === -2 && (!emailVerify || (kycType === 1 && !phoneVerify))) {
        return -3;
    }
    return status;
};



// WEBPACK FOOTER //
// ./src/store/getters.js